<template>
  <div class="menu-wrapper">
    <el-menu-item :index="String(item.id)" v-if="!item.childs || item.childs.length === 0">
      <i class="el-icon-menu"></i>
      <!-- <svg-icon v-if="onlyOneChild.meta&&onlyOneChild.meta.icon"
                :icon-class="onlyOneChild.meta.icon"></svg-icon> -->
      <span slot="title">{{ item.name }}</span>
      <div class="operation">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-more"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-plus" v-if="item.id <= 4" @click.native="handleCommand(1, item)">新增二级
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-circle-plus" v-if="item.id > 4" @click.native="handleCommand(2, item)">编辑二级
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-circle-plus-outline" v-if="item.id > 4 && item.childs.length === 0"
              @click.native="handleCommand(3, item)">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu-item>
    <el-submenu :index="String(item.id)" v-else>
      <template slot="title">
        <i class="el-icon-menu"></i>
        <!-- <svg-icon v-if="item.meta&&item.meta.icon"
                  :icon-class="item.meta.icon"></svg-icon> -->
        <span slot="title">{{ item.name }}</span>
        <div class="operation" @click.stop="">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-plus" v-if="item.id <= 4" @click.native="handleCommand(1, item)">新增二级
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-circle-plus" v-if="item.id > 4" @click.native="handleCommand(2, item)">编辑二级
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-circle-plus-outline" v-if="item.id > 4 && item.childs.length === 0"
                @click.native="handleCommand(3, item)">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-for="child in item.childs">
        <help-item :is-nest="true" class="nest-menu" @edits="edits" @deletes="deletes" :item="child" :key="child.id">
        </help-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'

export default {
  name: 'HelpItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    handleCommand(index, item) {
      switch (index) {
        case 1:
          this.addChild(item)
          break
        case 2:
          this.editChild(item)
          break
        case 3:
          this.deleteChild(item)
          break

        default:
          break
      }
    },
    addChild(item) {
      this.$emit('add', item.id)
    },
    addConfim() {
      this.$httpAuth
        .post('/v1/backendHelpRpc/addSubCategory', {
          fatherId: this.addForm.fatherId,
          name: this.addForm.name,
          sort: Number(this.addForm.sort),
          businessType: 1
        })
        .then((res) => {
          this.$emit('getitems')
          this.$notify({
            title: '提示',
            message: '保存成功',
          })
          this.addVisible = false
        })
    },
    editChild(item) {
      this.$emit('edits', JSON.stringify(item))
    },
    deleteChild(item) {
      this.$emit('deletes', item.id)
    },
    edits(item) {
      this.$emit('edits', item)
    },
    deletes(id) {
      this.$emit('deletes', id)
    },
  },
}
</script>
<style scoped>
.operation {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%) rotateZ(90deg);
}
</style>
<style>
.el-submenu__icon-arrow {
  display: none !important;
}
</style>

